export default "__VITE_ASSET__C$9skQ$J__"